import { render } from "./HangulRiver.vue?vue&type=template&id=6422a668"
import script from "./HangulRiver.vue?vue&type=script&lang=js"
export * from "./HangulRiver.vue?vue&type=script&lang=js"
script.render = render

export default script